/**  @type { Styles } */
import { commonStyles } from '../../../../styles/common.styles'

export const styles = {
  dateWrapper: { display: 'flex', gap: 2 },
  endDateField: { ...commonStyles.endDateStyle, cursor: 'pointer' },
  endDateFieldHorizontal: { ...commonStyles.fullWidth, cursor: 'pointer' },
}
